require('dotenv').config();

import Vue from 'vue';
import VueSocialSharing from 'vue-social-sharing';
import Toasted from 'vue-toasted';
import VueClipboard from 'vue-clipboard2'

import App from './App.vue'
import './assets/stylesheets/application.scss';

Vue.config.productionTip = false

Vue.use(VueSocialSharing);
Vue.use(VueClipboard);

Vue.use(Toasted, {
  position: 'bottom-center',
  duration: 3000,
  type: 'info',
  classname: 'toasted',
});

new Vue({
  render: h => h(App)
}).$mount('#app')